
import React from 'react';
import { LegalPageLinks } from '@/components/legal/LegalPageLinks';
import { Helmet } from 'react-helmet-async';
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const Cookie = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Cookie Policy | How Fly Uses Cookies on This Site</title>
        <meta name="description" content="Learn which cookies Fly sets on this site, what each one is used for, how long it lasts, and how you can control or clear them from your browser." />
        <meta name="keywords" content="cookie policy, cookies, website cookies, tracking cookies" />
        <link rel="canonical" href="https://www.fly-social.com/cookie-policy" />
      </Helmet>
      <NavBar />
      
      {/* One centred reading column, about 75 characters at prose-lg. */}
      <div className="container mx-auto px-5 pt-28 md:pt-36 pb-16">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-3">Cookie Policy</h1>
          <p className="text-gray-600 mb-4">Last updated: 15 May 25</p>

          <div className="prose prose-lg prose-slate max-w-none">
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to the website owners.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Cookies</h2>
            <p>
              We use cookies for the following purposes:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Essential cookies:</strong> These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
              <li><strong>Performance cookies:</strong> These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</li>
              <li><strong>Functionality cookies:</strong> These cookies enable the website to provide enhanced functionality and personalization.</li>
              <li><strong>Targeting cookies:</strong> These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant advertisements on other sites.</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Types of Cookies We Use</h2>
            <p>
              <strong>Session Cookies:</strong> These cookies are temporary and are deleted from your device when you close your web browser.
            </p>
            <p>
              <strong>Persistent Cookies:</strong> These cookies remain on your device until they expire or you delete them. They help us recognize you as an existing user.
            </p>
            <p>
              <strong>First-Party Cookies:</strong> These cookies are set by our website.
            </p>
            <p>
              <strong>Third-Party Cookies:</strong> These cookies are set by third parties, such as Google Analytics, to collect information about how visitors use our website.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience.
            </p>
            
          </div>

          <LegalPageLinks current="/cookie-policy" />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Cookie;
